import { useState, useEffect } from 'react';
import { Container, Spinner, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { getPerformanceRecords } from '../../api/userApi';
import { fmtIST } from '../../utils/dateFormat';

const cyan = '#00e5ff';

const PerformanceRecords = () => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    getPerformanceRecords()
      .then((res) => setData(res.data))
      .catch(() => setError('Failed to load performance bonus data.'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#0a0a0a', paddingBottom: 48 }}>
      <Container className="pt-4" style={{ maxWidth: 680 }}>

        <button
          onClick={() => navigate('/dashboard')}
          style={{ background: 'none', border: 'none', color: cyan, fontSize: 13, cursor: 'pointer', marginBottom: 20, padding: 0 }}
        >
          ‹ Back to Dashboard
        </button>

        <h5 style={{ color: '#fff', fontWeight: 700, marginBottom: 24 }}>Performance Bonus</h5>

        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" style={{ color: cyan }} />
          </div>
        ) : error ? (
          <div style={{ color: '#ff6666', textAlign: 'center', marginTop: 40 }}>{error}</div>
        ) : (
          <>
            {/* Total Earned */}
            <div style={{
              background: 'radial-gradient(ellipse at 0% 100%, rgba(102,255,153,0.1) 0%, #0d0d0d 60%)',
              border: '1px solid rgba(102,255,153,0.2)',
              borderRadius: 14,
              padding: '24px 28px',
              marginBottom: 28,
            }}>
              <div style={{ color: '#888', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 8 }}>
                Total Performance Bonus Earned
              </div>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 10 }}>
                <span style={{ fontSize: 42, fontWeight: 900, color: '#66ff99', textShadow: '0 0 24px rgba(102,255,153,0.3)' }}>
                  {data.totalEarned.toFixed(2)}
                </span>
                <span style={{ color: '#aaa', fontSize: 16, fontWeight: 500 }}>USDT</span>
              </div>
            </div>

            {/* Earning Records */}
            <div style={{ color: '#aaa', fontSize: 13, fontWeight: 600, marginBottom: 12 }}>Earning Records</div>
            <div style={{ borderRadius: 12, overflow: 'hidden', border: '1px solid rgba(0,229,255,0.12)' }}>
              <Table responsive className="mb-0" style={{ background: 'transparent' }}>
                <thead>
                  <tr style={{ background: 'rgba(0,229,255,0.07)', borderBottom: '1px solid rgba(0,229,255,0.15)' }}>
                    <th style={{ color: cyan, fontWeight: 600, fontSize: 13, padding: '12px 20px', border: 'none', whiteSpace: 'nowrap' }}>Date</th>
                    <th style={{ color: cyan, fontWeight: 600, fontSize: 13, padding: '12px 20px', border: 'none', whiteSpace: 'nowrap' }}>Amount</th>
                    <th style={{ color: cyan, fontWeight: 600, fontSize: 13, padding: '12px 20px', border: 'none', whiteSpace: 'nowrap' }}>Comments</th>
                  </tr>
                </thead>
                <tbody>
                  {data.records.length === 0 ? (
                    <tr>
                      <td colSpan={3} style={{ color: '#555', textAlign: 'center', padding: '32px', border: 'none' }}>
                        No performance bonus records yet
                      </td>
                    </tr>
                  ) : (
                    data.records.map((r) => (
                      <tr key={r._id} style={{ borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                        <td style={{ color: '#888', fontSize: 12, padding: '12px 20px', border: 'none', whiteSpace: 'nowrap' }}>
                          {fmtIST(r.createdAt)}
                        </td>
                        <td style={{ color: '#66ff99', fontWeight: 600, fontSize: 13, padding: '12px 20px', border: 'none', whiteSpace: 'nowrap' }}>
                          + {Number(r.amount).toFixed(2)} USDT
                        </td>
                        <td style={{ color: '#aaa', fontSize: 12, padding: '12px 20px', border: 'none', whiteSpace: 'nowrap' }}>
                          {r.comments || '—'}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
          </>
        )}
      </Container>
    </div>
  );
};

export default PerformanceRecords;
